import { Confirmation } from "./dialogTypes/Confirmation";
import { Destructive } from "./dialogTypes/Destructive";
import { MultiStep } from "./dialogTypes/MultiStep";
import { Passive } from "./dialogTypes/Passive";

export const Dialog = {
  Passive,
  Destructive,
  Confirmation,
  MultiStep,
};
